import { useState } from "react";
import { useMutation } from "@apollo/client";

import { Game } from "../../../../../../../gql/graphql";
import { isWordopolisGame } from "../../../../../../../graphql/helpers/isWordopolisGame";
import { WORDOPOLIS_CONFIGURATION_UPDATE } from "../../../../../../../graphql/mutations/GameMutation";
import { ScaleQuestionSectionTemplate } from "../../../../../../shared/ScaleQuestionSectionTemplate";
import { RatingQuestionConfig } from "../../../../../../shared/ScaleQuestionSectionTemplate/ScaleQuestionSectionTemplate";

export interface ScaleQuestionSectionProps {
  game: Game;
}

export const ScaleQuestionSection = ({ game }: ScaleQuestionSectionProps) => {
  const [updateWordopolisConfig] = useMutation(WORDOPOLIS_CONFIGURATION_UPDATE);

  const [scaleQuestionConfig, setScaleQuestionConfig] = useState<RatingQuestionConfig>({
    question: isWordopolisGame(game) ? game.configuration.ratingQuestion : "",
    leftLabel: isWordopolisGame(game) ? game.configuration.ratingRightLabel : "",
    rightLabel: isWordopolisGame(game) ? game.configuration.ratingLeftLabel : "",
    scaleSize: isWordopolisGame(game) ? game.configuration.ratingScaleSize : 0,
  });

  const handleSave = (config: RatingQuestionConfig) => {
    updateWordopolisConfig({
      variables: {
        wordopolisConfigurationId: game.configuration.id,
        data: {
          ratingQuestion: config.question,
          ratingLeftLabel: config.leftLabel,
          ratingRightLabel: config.rightLabel,
          ratingScaleSize: config.scaleSize,
        },
      },
    });
  };

  return (
    <ScaleQuestionSectionTemplate
      value={scaleQuestionConfig}
      onChange={(value: RatingQuestionConfig) => {
        setScaleQuestionConfig(value);
        handleSave(value);
      }}
    />
  );
};
